<template>
    <div>
        <div v-if="showBackdrop" class="modal-backdrop-between" @click="modal.hide()"></div>

        <div class="modal attendance-modal fade" id="addOfferToConversationModal" tabindex="-1" aria-labelledby="addOfferToConversationModal" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Opdracht koppelen</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-3 px-4 pb-3">
                    <!-- Search section -->
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Zoek opdracht</label>
                        <div class="mb-4 flex gap-2">
                            <div class="flex-grow">
                                <!-- Eerste rij met volledig breedte zoekveld -->
                                <div class="w-full mb-2">
                                    <input
                                        type="text"
                                        class="w-full form-control"
                                        v-model="searchQuery"
                                        :disabled="searchQueryZipCode.length > 0"
                                        placeholder="Zoek op dossier of opdracht #"
                                        v-on:keyup.enter="searchEntities()"
                                    >
                                </div>
                                <!-- Tweede rij met postcode en huisnummer -->
                                <div class="w-full flex gap-2">
                                    <div class="flex-1">
                                        <input
                                            type="text"
                                            class="w-full form-control"
                                            v-model="searchQueryZipCode"
                                            :disabled="searchQuery.length > 0"
                                            placeholder="Zoek op postcode"
                                        >
                                    </div>
                                    <div class="flex-1">
                                        <input
                                            type="text"
                                            class="w-full form-control"
                                            v-model="searchQueryHouseNo"
                                            :disabled="searchQuery.length > 0"
                                            placeholder="Zoek op huisnummer"
                                        >
                                    </div>
                                </div>
                            </div>
                            <!-- Zoekknop met volledige hoogte -->
                            <button
                                class="btn btn-outline-secondary h-full flex items-center justify-center"
                                type="button"
                                @click="searchEntities()"
                            >
                                <i class="fa fa-search"
                                   :class="{ 'fa fa-circle-o-notch fa-spin' : this.searchLoader }"></i>
                            </button>
                        </div>
                    </div>

                    <div v-if="searchResults.length > 0">
                        <label class="form-label fw-semibold">Resultaten</label>
                        <div class="list-group">
                            <a
                                v-for="result in searchResults"
                                href="#"
                                class="list-group-item list-group-item-action"
                                @click.prevent="selectOrder(result)"
                            >
                                <div class="w-full flex gap-2">
                                    <div>{{ result.item_dossier_nr }}</div>
                                    <div>{{ result.item_name }}</div>
                                    <div class="ms-auto">
                                        <small class="d-block text-muted">{{ result.item_status }}</small>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div v-if="selectedOrder" class="mt-3 order-select-container">
                        <span class="form-label fw-semibold">Geselecteerde opdracht #{{ selectedOrder.item_dossier_nr }} - {{ selectedOrder.item_name }}</span>
                    </div>

                    <div class="modal-body pt-3 px-4 pb-4 d-flex">
                        <button
                            class="btn btn-primary ms-auto px-3 py-2 text-sm"
                            @click="assignOffer()"
                            :disabled="!selectedOrder"
                        >Opslaan <i :class="{ 'fa fa-circle-o-notch fa-spin' : this.btnActionLoader }"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'add-offer-to-conversation-modal',
    data() {
        return {
            searchQuery: '',
            searchQueryZipCode: '',
            searchQueryHouseNo: '',
            searchResults: [],
            selectedOrder: null,
            conversationId: null,
            searchLoader: false,
            btnActionLoader: false,
            showBackdrop: false
        }
    },
    methods: {
        searchEntities() {
            if (this.searchQuery.trim() === '' && this.searchQueryZipCode.trim() === '') {
                this.searchResults = [];
                return;
            }

            this.searchLoader = true;

            axios.get('api/search-entities', {
                params: {
                    query: this.searchQuery,
                    queryZipCode: this.searchQueryZipCode,
                    queryHouseNo: this.searchQueryHouseNo
                }
            })
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }
                    this.searchResults = response.data || [];
                    this.searchLoader = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het zoeken.", "error");
                    this.searchLoader = false;
                });
        },
        selectOrder(order) {
            this.selectedOrder = order;
            this.searchResults = [];
            this.searchQuery = '';
            this.searchQueryZipCode = '';
            this.searchQueryHouseNo = '';
        },
        assignOffer() {
            if (!this.selectedOrder) {
                return;
            }

            this.btnActionLoader = true;

            axios.post('api/assign-offer-to-conversation', {
                orderId: this.selectedOrder.id,
                type: this.selectedOrder.type,
                conversationId: this.conversationId
            })
            .then(response => {
                if (response.data.status === 422) {
                    this.modal.hide();
                    throw [true, response.data.message];
                }

                EventBus.$emit('refetchConversations');
                EventBus.$emit('conversationUpdated', this.conversationId);
                this.resetForm();
                this.btnActionLoader = false;

                setTimeout(() => this.modal.hide(), 500);

                this.$swal("Succes", "De opdracht is gekoppeld.", "success");
            })
            .catch(e => {
                this.btnActionLoader = false;
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
            });
        },
        resetForm() {
            this.searchQuery = '';
            this.searchQueryZipCode = '';
            this.searchQueryHouseNo = '';
            this.searchResults = [];
            this.selectedOrder = null;
        }
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('addOfferToConversationModal'));

        // Show/hide backdrop when modal opens/closes
        const modalElement = document.getElementById('addOfferToConversationModal');
        modalElement.addEventListener('show.bs.modal', () => {
            this.showBackdrop = true;
        });
        modalElement.addEventListener('hidden.bs.modal', () => {
            this.showBackdrop = false;
        });

        EventBus.$on('addOfferToConversation', (data) => {
            this.conversationId = data.conversationId;
            this.resetForm();
            this.modal.show();
        });
    },
}
</script>

<style>
input.form-control {
    &:disabled {
        background: #f7f7f7;
    }
}

.order-select-container {
    padding: 1em;
    background-color: #F6BF40;
    border: 1px solid #F6BF40;
    border-radius: 3px;
}

.modal-backdrop-between {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10000;
    cursor: pointer;
}
</style>
